import { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api, resolveImage } from "@/lib/api";
import { toast } from "sonner";

export const ImageUploader = ({ value, onChange, label, testid }) => {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="h-20 w-28 shrink-0 bg-black border border-white/15 overflow-hidden grid place-items-center">
        {value ? (
          <img src={resolveImage(value)} alt={label} className="w-full h-full object-cover" />
        ) : (
          <span className="text-white/30 text-xs">No image</span>
        )}
      </div>
      <div className="flex-1">
        <label
          className="inline-flex items-center gap-2 px-4 py-2.5 border border-white/20 text-white text-sm font-medium uppercase tracking-wider cursor-pointer hover:bg-white hover:text-black transition-colors"
          data-testid={testid}
        >
          {uploading ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}
          {uploading ? "Uploading..." : "Upload Image"}
          <input type="file" accept="image/*" className="hidden" onChange={handleFile} disabled={uploading} />
        </label>
        <input
          className="mt-2 w-full bg-black border border-white/10 px-3 py-2 text-xs text-white/50 focus:border-ad-red focus:outline-none"
          placeholder="or paste image URL"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
};
